<template>
  <!--  서브페이지  -->

  <!--콘텐츠 영역-->
  <div id="sub_contents" class="sub_contents">

    <a @click="btnWrite" v-if="isAdmin" class="admin writing">배너 추가</a>

    <p v-if="!isAdmin">
      로그인이 필요합니다.
    </p>


    <div class="News_list">

      <ul class="list">
        <li v-for="(obj, index) in bannerList" :key="index">
          <a @click="btnDetail(obj)">
            <dl>
              <!-- <dd class="img">
                <img :src="obj.MAIN_IMG" />
              </dd> -->
              <dt>{{ obj.title }}</dt>
              <dd>생성일 : {{ obj.createdAt | date }}</dd>
              <dd>게시기간 : {{ obj.startDt | date }} ~ {{ obj.endDt | date }}</dd>
              <dd>타입 : {{ obj.selectedTypeText}}</dd>

            </dl>
          </a>
        </li>
      </ul>
    </div>

    <router-view />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import pm from "../common/protocolManager";
import { bannerSelectType } from "../common/util";
export default {
  data: () => ({
    message: "BannerList.vue",
    isAdmin: false,
    bannerList : [],
  }),
  methods: {
    getList() {

      let url = "bannerList";
      pm.get(url)
        .then(result => {
          console.log('bannerList = ok');


          console.log(`bannerList.length = ${result.list.length} `);

          if (result.list.length) {
            let tempTypeList = bannerSelectType();

            for (let i = 0; i < result.list.length; i++){
              // result.list[i].MAIN_IMG = require('../../assets/img/ntalk.png');
              // if (result.list[i].files && result.list[i].files.bgImage.length) {
              //   result.list[i].MAIN_IMG =
              //     pm.NAS_URL + result.list[i].files.bgImage[0].filename;
              // }

              for (let j = 0; j < tempTypeList.length; j++) {
                if (tempTypeList[j].value == result.list[i].type) {
                  result.list[i].selectedTypeText = tempTypeList[j].name;
                }
              }

              this.bannerList.push(result.list[i]);
            }
          }

        })
        .catch(err => {
          console.log('bannerList = err');
        });

    },
    btnDetail(obj) {
      this.$router.push({
        path: `/notice/bannerdetail`,
        query: {
          id: obj._id,
        }
      });
    },
    btnWrite() {
      console.log('BannerWritePopup');
      this.$router.push({
        path: `/notice/BannerWritePopup`,
        query: {
          // id: '63b381bb12e1a0174b6cce42',
          // 게시판 타입 = 0 : 공지사항, 1 : 소식,
          type: 1,
        }
      });
    },
    checkAdmin() {
      let url = "isAdmin";
      pm.get(url)
        .then(result => {
          console.log('isAdmin = true');
          this.isAdmin = true;
        })
        .catch(err => {
          console.log('isAdmin = err');
          this.isAdmin = false;
          if (localStorage.authToken) {
            localStorage.removeItem("authToken");
          }
        });
    },

  },
  computed: {

    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    },

  },
  destroyed() { },
  mounted() {
    this.checkAdmin();
    this.getList();
  },
  created() {
    console.log("created - " + this.message);

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub02/BannerList.vue